<template>
  <div class="kpi">
    <span>
      <h2>{{ data }}</h2>
      {{ units }}
    </span>
    <i v-if="icon" :class="icon"></i>
  </div>
</template>

<script>
import DataService from '../../../../services/data.service';

export default {
  name: 'kpi-panel',
  components: {},
  props: {
    dateRange: {
      type: Object,
      default: undefined,
    },
    filter: {
      type: Object,
      default: undefined
    },
    panel: {
      type: Object,
      default: () => {}
    },
  },
  data: function () {
    this.filter.activeFiltersUpdated.add(this.renewRegistration.bind(this));
    return {
      data: 0,
      units: this.panel.units || '',
      icon: this.panel.icon || '',
    }
  },
  methods: {
    renewRegistration: function() {
      DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
      DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData.bind(this));
    },
    updateData: function(data) {
      if (data.length === 0) {
        this.data = 0;
        return;
      }
      if (this.panel.kpiColumn) {
        this.data = formatNumericValueWithSuffix(data[0][this.panel.kpiColumn], 0);
      } else {
        this.data = formatNumericValueWithSuffix(this.data[0], 0);
      }
    }
  },
  mounted() {
    DataService.registerPanel(this.panel, this.filter, this.dateRange, this.updateData);
  },
  beforeDestroy() {
    DataService.deregisterPanel(this.panel, this.filter, this.dateRange);
  },
  watch: {
    dateRange: {
      handler: function(newRange, oldVal) {
        if (!newRange.startDate.isSame(oldVal.startDate) || !newRange.endDate.isSame(oldVal.endDate)) {
          this.renewRegistration();
        }
      },
      deep: true,
    },
  },
}

function isInteger(n) {
    return n === +n && n === (n | 0);
}

function formatNumericValueWithSuffix(val, defaultVal) {
    var ranges = [
        { divider: 1e9, suffix: 'B' },
        { divider: 1e6, suffix: 'M' },
        { divider: 1e3, suffix: 'k' }
    ];

    for (var i = 0; i < ranges.length; i++) {
        if (val >= ranges[i].divider) {
            return (val / ranges[i].divider).toFixed(1).toString() + ranges[i].suffix;
        }
    }

    if (isInteger(val)) {
        return val;
    }

    var result = parseFloat(val).toFixed(1);

    if (isNaN(result)) {
        return (defaultVal !== null) ? defaultVal : null;
    }
    return result;
}
</script>

<style lang="scss" scoped>
.kpi {
  color: var(--text-color);
  display: flex;
  justify-content: space-between;
  padding: 5px 20px;
  h2 {
    margin: 0;
    display: inline-block;
    font-size: 40px;
  }
  i {
    margin-left: auto;
    font-size: 40px;
  }
}
</style>
